
/* VENDORS */
export const GET_VENDORS_LISTING = "GET_VENDORS_LISTING";
export const GET_VENDORS_LISTING_SUCCESS = "GET_VENDORS_LISTING_SUCCESS";
export const GET_VENDORS_LISTING_FAIL = "GET_VENDORS_LISTING_FAIL";

export const GET_VENDORS_DETAILS = "GET_VENDORS_DETAILS";
export const GET_VENDORS_DETAILS_SUCCESS = "GET_VENDORS_DETAILS_SUCCESS";
export const GET_VENDORS_DETAILS_FAIL = "GET_VENDORS_DETAILS_FAIL";

export const ADD_VENDORS = "ADD_VENDORS";
export const ADD_VENDORS_SUCCESS = "ADD_VENDORS_SUCCESS";
export const ADD_VENDORS_FAIL = "ADD_VENDORS_FAIL";

export const UPDATE_VENDORS = "UPDATE_VENDORS";
export const UPDATE_VENDORS_SUCCESS = "UPDATE_VENDORS_SUCCESS";
export const UPDATE_VENDORS_FAIL = "UPDATE_VENDORS_FAIL";

export const DELETE_VENDORS = "DELETE_VENDORS";
export const DELETE_VENDORS_SUCCESS = "DELETE_VENDORS_SUCCESS";
export const DELETE_VENDORS_FAIL = "DELETE_VENDORS_FAIL";

export const EXPORT_VENDORS = "EXPORT_VENDORS";
export const EXPORT_VENDORS_SUCCESS = "EXPORT_VENDORS_SUCCESS";
export const EXPORT_VENDORS_FAIL = "EXPORT_VENDORS_FAIL";

export const RESET_VENDORS_STATE = 'RESET_VENDORS_STATE';
export const RESET_VENDORS_ATTACHMENT_STATE = 'RESET_VENDORS_ATTACHMENT_STATE';